$(function () {
    $.nette.init();
});

//bind and init css and events (onLoan and after ajax)
function initEventsWithReloadCommon() {
    enableConfirms();
}

//bind and init css and events (onLoan only, no ajax)
function initEventsOnceCommon()
{

}

function enableConfirms()
{
    $('a[data-confirm]:not(.ajax), button[data-confirm]:not(.ajax), input[data-confirm]:not(.ajax)').on('click', function (e) {
        if (!confirm($(this).attr('data-confirm'))) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
    });
}

//disable spiner if back/forward button
if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
    $('.ajax-loading').hide();
}

function goTop(speed) {
    if (typeof(speed)==='undefined') speed = 0;
    $('html, body').animate({
        scrollTop: 0
    },speed);
}

function goTopOfElement(target, addOffset, speed) {
    if (typeof(speed)==='undefined') speed = 0;
    if (typeof(addOffset)==='undefined') addOffset = 0;

    var jqueryTarget = $(target);
    if (jqueryTarget.length) {
        $('html, body').stop().animate({
            scrollTop: (jqueryTarget.offset().top - addOffset)
        }, speed);
    }
}
